import { render, staticRenderFns } from "./tkReduce.vue?vue&type=template&id=88ec3c0a&scoped=true&"
import script from "./tkReduce.vue?vue&type=script&lang=js&"
export * from "./tkReduce.vue?vue&type=script&lang=js&"
import style0 from "./tkReduce.vue?vue&type=style&index=0&id=88ec3c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ec3c0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDialog,VIcon,VLayout,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
